import { AvatarPicture } from '../avatar/AvatarPicture';
import { DIMENSION_AVATAR_VERY_SMALL } from '../../constants';
import { getIsUserInactive } from '../../lib/getIsUserActive';
import { Box } from '@mui/material';
import keyBy from 'lodash/keyBy';
import { useSelector } from 'react-redux';
import { selectAccountUsers } from '../../reducers/accountUsersReducer';
import sweepBugImg from './SweepBug.png';
import { Typography } from '@sweep-io/sweep-design';

const UserNameForTable = ({
  userId,
  renderAsSweep,
}: {
  userId: string;
  renderAsSweep?: boolean;
}) => {
  const accountUsers = keyBy(useSelector(selectAccountUsers), 'id');
  const _user = accountUsers[userId];
  const sweepUser = {
    name: 'Sweep',
    emoji: undefined,
    imageUrl: sweepBugImg,
    status: 'active',
  };
  const user = renderAsSweep ? sweepUser : _user;

  if (!_user) return null;

  return (
    <Box display="flex" gap={0.5} alignItems="center" overflow="hidden">
      <AvatarPicture
        avatar={{ emoji: user.emoji, imageUrl: user.imageUrl }}
        dimension={DIMENSION_AVATAR_VERY_SMALL}
        clickable={false}
        isInactive={getIsUserInactive(user.status)}
      />
      <Typography variant="body">{user.name}</Typography>
    </Box>
  );
};

export default UserNameForTable;
